import React, { useState } from "react";
import { useValidator } from "react-joi";
import { useCookies } from "react-cookie";
// ======= Bootstrp Components=======
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
// components
import Logo from "../../../assets/img/Logo.svg";
import Message from "../../utils/modals/Message";
import { loginSetData } from "../../../context/api/login/loginSetData";
import { loginSchema } from "../../joi/loginSchema";
import { joiErrorMessage } from "../../utils/extra/joiErrorMessage";

const Login = ({ lang, setAuth }) => {
  const data = require(`../../../translate/${
    lang === "AR" ? "arabic" : "english"
  }/data.json`);
  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const [cookies, setCookie] = useCookies();
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [btnLoader, setBtnLoader] = useState(false);

  const schema = loginSchema(lang).schema;
  const { state, setData, setExplicitField, validate } = useValidator(schema);

  const updateEmail = (e) => {
    setData((old) => ({
      ...old,
      email: e.target.value,
    }));
  };

  const updatePassword = (e) => {
    setData((old) => ({
      ...old,
      password: e.target.value,
    }));
  };

  const postData = (e) => {
    e.preventDefault();
    const credintial = {
      email: state.$data.email,
      password: state.$data.password,
    };

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return loginSetData(
        lang,
        credintial,
        setAuth,
        setMessageResponse,
        setCookie,
        setBtnLoader
      );
    }
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <div className="login_p d-flex align-items-center justify-content-center">
        <div className="login_p-form d-flex flex-column align-items-center">
          <img src={Logo} width={250} alt="Amar" className="mt-5" />

          <Form
            className="w-100 px-4 pb-4"
            dir={lang === "AR" ? "rtl" : "ltr"}
            onSubmit={(e) => {
              validate();
              postData(e);
            }}
          >
            <Form.Group className="my-5" controlId="formBasicEmail">
              <Form.Label>{data.pages.login_p.email}</Form.Label>
              <Form.Control
                className="login_p-form-inputs"
                type="text"
                placeholder={data.pages.login_p.email_placeholder}
                onChange={updateEmail}
                onBlur={() => setExplicitField("email", true)}
              />
              <Form.Text style={{ color: "red" }}>
                {joiErrorMessage(state.$errors.email)}
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-5" controlId="formBasicPassword">
              <div className="login-pass-label w-100 d-flex flex-row justify-content-between">
                <Form.Label>{data.pages.login_p.password}</Form.Label>
                <a href="/forget-pass">{data.pages.login_p.forget_pass}</a>
              </div>
              <Form.Control
                className="login_p-form-inputs"
                type="password"
                placeholder={data.pages.login_p.password_placeholder}
                onChange={updatePassword}
                onBlur={() => setExplicitField("password", true)}
              />
              <Form.Text style={{ color: "red" }}>
                {joiErrorMessage(state.$errors.password)}
              </Form.Text>
            </Form.Group>

            <Button
              className="login-btn w-100"
              variant="primary"
              type="submit"
              disabled={btnLoader ? true : false}
            >
              {data.pages.login_p.login}
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Login;
